/**
 * fix.ai — AI avto-detal maslahatchisi (Gemini orqali).
 *
 * Mijoz mashinasi muammosini yozadi ("shu joyi ishlamayapti") → fix.ai aynan
 * qaysi zapchast kerakligini aytadi + maslahat beradi + katalogdan mos
 * mahsulotlarni ko'rsatadi. Provayder: Google Gemini (GEMINI_API_KEY).
 */
import { z } from 'zod';
export const fixAiDiagnoseSchema = z.object({
    /** Mijoz muammosi (erkin matn). */
    problem: z.string().trim().min(5, 'Muammoni batafsilroq yozing').max(1000),
    /** Ixtiyoriy: mashina (marka/model/yil/dvigatel) — aniqroq tavsiya uchun. */
    car: z.string().trim().max(160).optional(),
});
//# sourceMappingURL=fix-ai.schema.js.map